import { Pipe, PipeTransform } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

@Pipe({ name: 'timeAgo' })
export class TimeAgoPipe implements PipeTransform {
  transform(datetime: Timestamp | Date | string) {
    if (!datetime) return datetime;

    if (datetime instanceof Timestamp) return dayjs(datetime.seconds, 'X').fromNow();
    if (datetime instanceof Date) return dayjs(datetime).fromNow();
    if (typeof datetime === 'string') {
      if (Number.isNaN(Number(datetime))) return dayjs(new Date(datetime)).fromNow();
      else return dayjs(Number(datetime)).fromNow();
    }
  }
}
